import {Pipe, PipeTransform} from '@angular/core';
import {differenceInMinutes, differenceInSeconds} from 'date-fns/esm';
import {parseToDate} from '../../shared/utils';

@Pipe({
  name: 'qmDateDiff'
})
export class QmDateDiffPipe implements PipeTransform {

  transform(left: Date | string | number, right: Date | string | number, unit: 'm' | 's'): number {
    left = parseToDate(left);
    right = parseToDate(right);
    switch (unit) {
      case 'm':
        return differenceInMinutes(left, right);
      case 's':
        return differenceInSeconds(left, right);
      default:
        return differenceInMinutes(left, right);
    }
  }

}
